module.exports = __webpack_public_path__ + "assets/red-hat-linux.303b73db.svg";